export default __webpack_public_path__ + "static/media/291.de8de162.jpg";